import { getAssignmentById } from "@/api/assignment"
import { AssignmentProps } from "@/interfaces/assignment_types"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { TaskForm } from "../Tasks/Form/TaskForm"
import { TaskProps } from "@/interfaces/tasks_types"
import { useAuth } from "@/App"
// THIS FORM USES THE TASK FORM BECAUSE IT IS IDENTICAL TO IT

export function EditAssignment() {
    const { id } = useParams<string>()

    const [assignment, setAssignment] = useState<AssignmentProps>()
    
    useEffect(() => {
        if (!id) return
        const fetchAssignment = async () => {
            const assignment = await getAssignmentById(id)
            setAssignment(assignment)
        }

        fetchAssignment()
    }, [id])

    return (
        <>
            {assignment && <TaskForm method="PUT" task_data={assignment as TaskProps} is_assignment/>}
        </>
    )
}


/**
 *  ### Route for ('/tasks/feedback_assignment')
 * 
 *  This is triggered when a user clicks on the feedback assignment button in the nav bar
 * 
 */
export function FeedbackAssignment(){
    const { user } = useAuth()

    if (!user) {
        return <div>Loading...</div>
    }

    const feedback_data: TaskProps = {
      task_id: "",
      project: "",
      title: "",
      description: "",
      assigned_by: user.name,
      assigned_by_obj: {
        name: user.name,
        email: user.email,
        id: user.id,
        username: user.username,
        password: user.password,
        role: user.role
      },
      assigned_to: "Admin",
      project_id: "",
      due_date: new Date().toLocaleDateString('en-CA'),
      category: "Other",
      status: "Active",
      completion_percentage: 0
    }
  
    return (
        <TaskForm method="POST" task_data={feedback_data} is_assignment/>
    )
}